import {SerializedStyles} from '@emotion/react';
import {useTheme, css} from '@mui/material';
import * as React from 'react';

import {GetStylesFunction} from '../common';

type Props = {
  badgeContent?: string | JSX.Element;
  wrapperCss?: SerializedStyles;
  inputCss?: SerializedStyles;
  xOffset?: number;
  yOffset?: number;
};

export const BadgeWrapper: React.FC<Props> = (props) => {
  const {children, badgeContent, wrapperCss, inputCss, xOffset = 0, yOffset = 0} = props;

  const theme = useTheme();
  const styles = getStyles({
    theme,
    params: {wrapperCss, inputCss, xOffset, yOffset},
  });

  return (
    <div css={styles.badgeWrapper}>
      {children}
      <div css={styles.badgeContent}>{badgeContent}</div>
    </div>
  );
};
BadgeWrapper.displayName = 'BadgeWrapper';

const getStyles: GetStylesFunction = (options) => ({
  badgeWrapper: css`
    position: relative;
    overflow: visible;
    ${options?.params?.wrapperCss ?? ''};
  `,
  badgeContent: css`
    position: absolute;
    left: calc(100% + ${options?.params?.xOffset}px);
    bottom: calc(100% + ${options?.params?.yOffset}px);
    transform: translate(-50%, 50%);
    ${options?.params?.inputCss ?? ''};
  `,
});
